import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SportsDetailPage } from './sports-detail';
import { SharedModule } from '../../shared/shared.module';
import { BaselineSharedModule } from 'baseline-lib';
import { SportsListingComponent } from '../sports-listing/sports-listing';
import { SportsFilterComponent } from '../sports-filter/sports-filter';
import { SportsFullDetailCompComponent } from '../sports-full-detail-comp/sports-full-detail-comp';
import { LiveSportsFilterComponent } from '../live-sports-filter/live-sports-filter';

@NgModule({
  declarations: [
    SportsDetailPage,
    SportsFilterComponent,
    LiveSportsFilterComponent,
    SportsListingComponent,
    SportsFullDetailCompComponent
  ],
  imports: [
    SharedModule,
    BaselineSharedModule,
    IonicPageModule.forChild(SportsDetailPage),
  ],
  exports: [
    SportsDetailPage,
    SportsFilterComponent,
    LiveSportsFilterComponent,
    SportsListingComponent,
    SportsFullDetailCompComponent
  ]
})
export class SportsDetailPageModule {}



// WEBPACK FOOTER //
// ./src/app/sports/sports-detail/sports-detail.module.ts